/* Lovable Home — Sunna Shine 4.
   - Hero product-card slideshow (auto-advance, progress, dots, Mizaj badge, per-unit price)
   - Count-up numbers (data-countup)
   Re-inits on shopify:section:load so it works in the theme editor. */
(function () {
  var DURATION = 3500;
  var eur = new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" });
  function fmt(n) { return eur.format(n); }

  /* ---- Mizaj (Unani temperament) definitions ---- */
  var MIZAJ = {
    warmTrocken: { color: "oklch(0.58 0.21 28)", element: "Feuer", short: "warm & trocken",
      icon: '<path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"/>',
      bullets: ["Traditionell dem Element Feuer zugeordnet","In der Unani Lehre als „wärmende & trocknende“ Qualität beschrieben","Wird traditionell in kühleren, feuchten Jahreszeiten geschätzt","In heißen Sommerphasen traditionell sparsamer eingesetzt"] },
    warmFeucht: { color: "oklch(0.55 0.14 150)", element: "Luft", short: "warm & feucht",
      icon: '<path d="M17.7 7.7a2.5 2.5 0 1 1 1.8 4.3H2"/><path d="M9.6 4.6A2 2 0 1 1 11 8H2"/><path d="M12.6 19.4A2 2 0 1 0 14 16H2"/>',
      bullets: ["Traditionell dem Element Luft zugeordnet","In der Unani Lehre als „wärmende & befeuchtende“ Qualität beschrieben","Traditionell als nährende, aufbauende Speise verwendet","Wird in trockenen, kühleren Phasen bevorzugt"] },
    kaltFeucht: { color: "oklch(0.55 0.15 240)", element: "Wasser", short: "kalt & feucht",
      icon: '<path d="M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z"/>',
      bullets: ["Traditionell dem Element Wasser zugeordnet","In der Unani Lehre als „kühlende & befeuchtende“ Qualität beschrieben","Wird in warmen, trockenen Jahreszeiten traditionell geschätzt","In sehr kühlen Phasen traditionell zurückhaltender genutzt"] },
    kaltTrocken: { color: "oklch(0.42 0.06 55)", element: "Erde", short: "kalt & trocken",
      icon: '<path d="m8 3 4 8 5-5 5 15H2L8 3z"/>',
      bullets: ["Traditionell dem Element Erde zugeordnet","In der Unani Lehre als „kühlende & trocknende“ Qualität beschrieben","Wird traditionell in warmen, feuchten Phasen geschätzt","In der Unani Küche gerne mit wärmenden Zutaten kombiniert"] }
  };

  function parseBaseAmount(sub) {
    if (!sub) return null;
    var m = sub.match(/(?:(\d+)\s*[×x]\s*)?(\d+(?:[.,]\d+)?)\s*(kg|g|ml|l)\b/i);
    if (!m) return null;
    var mult = m[1] ? parseInt(m[1], 10) : 1;
    var val = parseFloat(m[2].replace(",", "."));
    var u = m[3].toLowerCase();
    var qty = val * mult, unit;
    if (u === "kg") unit = "kg";
    else if (u === "g") { qty = qty / 1000; unit = "kg"; }
    else if (u === "l") unit = "l";
    else { qty = qty / 1000; unit = "l"; }
    if (qty <= 0.04) return null;
    return { qty: qty, unit: unit };
  }

  function mizajHtml(key) {
    var m = MIZAJ[key];
    if (!m) return "";
    var tip = '<span class="lvh-mizaj__tip"><span class="lvh-mizaj__tiphead"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" style="color:' + m.color + '">' + m.icon + '</svg>Mizaj · ' + m.short + ' · Element ' + m.element + '</span>'
      + '<span class="lvh-mizaj__tipbody">Traditionelle Einordnung aus der Unani Medizin (Vier Säfte Lehre) – beschreibt die klassische Qualitätszuordnung, nicht die Temperatur des Produkts. Keine gesundheitsbezogene Aussage.</span><ul>';
    for (var i = 0; i < m.bullets.length; i++) tip += '<li><span class="dot"></span><span>' + m.bullets[i] + '</span></li>';
    tip += '</ul></span>';
    return '<span class="lvh-mizaj" tabindex="0" aria-label="Mizaj ' + m.short + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" style="color:' + m.color + '">' + m.icon + '</svg>' + tip + '</span>';
  }

  function initHero(root) {
    var card = root.querySelector("[data-lvh-hero-card]");
    if (!card) return;
    var dataEl = root.querySelector(".lvh-hero__data");
    var slides = [];
    if (dataEl) { try { slides = JSON.parse(dataEl.textContent); } catch (e) { slides = []; } }
    if (!slides.length) return;

    var q = function (s) { return card.querySelector(s); };
    var imgEl = q("[data-hero-img]"), offEl = q("[data-hero-off]"), mizEl = q("[data-hero-mizaj]"),
        nameEl = q("[data-hero-name]"), sizeEl = q("[data-hero-size]"), nowEl = q("[data-hero-now]"),
        wasEl = q("[data-hero-was]"), unitEl = q("[data-hero-unit]"), originEl = q("[data-hero-origin]"),
        dotsWrap = q("[data-hero-dots]"), countEl = q("[data-hero-count]"), barEl = q("[data-hero-bar]");

    var idx = 0, raf = null, startTime = null, destroyed = false, imageVersion = 0;
    var fallbackImg = imgEl ? (imgEl.getAttribute("src") || "") : "";
    var imageCache = Object.create(null);
    var activePrimary = fallbackImg, activeHover = "", isPointerOver = false;

    function requestImage(src, done) {
      done = typeof done === "function" ? done : function () {};
      if (!src) { done(false, ""); return; }
      var cached = imageCache[src];
      if (cached) {
        if (cached.state === "loaded") { done(true, src); return; }
        cached.callbacks.push(done);
        return;
      }
      var probe = new Image();
      var record = { state: "loading", callbacks: [done], probe: probe };
      var settled = false;
      var timer = null;
      imageCache[src] = record;
      function finish(ok) {
        if (settled) return;
        settled = true;
        if (timer) window.clearTimeout(timer);
        record.state = ok ? "loaded" : "error";
        var callbacks = record.callbacks.slice();
        record.callbacks.length = 0;
        if (!ok) delete imageCache[src];
        callbacks.forEach(function (cb) { cb(ok, src); });
      }
      probe.onload = function () { finish(probe.naturalWidth > 0); };
      probe.onerror = function () { finish(false); };
      timer = window.setTimeout(function () { finish(false); }, 8000);
      try {
        probe.decoding = "async";
        probe.src = src;
        if (probe.complete) finish(probe.naturalWidth > 0);
      } catch (e) {
        finish(false);
      }
    }

    function applyMainImage(src, name, version) {
      if (!imgEl || destroyed || version !== imageVersion) return;
      var target = src || fallbackImg;
      if (imgEl.getAttribute("src") === target) {
        imgEl.alt = name || "";
        return;
      }
      imgEl.classList.remove("lvh-fade");
      imgEl.src = target;
      imgEl.alt = name || "";
      void imgEl.offsetWidth;
      imgEl.classList.add("lvh-fade");
    }

    function updateProductImages(s) {
      var version = ++imageVersion;
      var primary = s.img || fallbackImg;
      var secondary = s.hoverImg && s.hoverImg !== primary ? s.hoverImg : "";
      activePrimary = fallbackImg;
      activeHover = "";
      applyMainImage(fallbackImg, s.name, version);

      requestImage(primary, function (ok, src) {
        if (destroyed || version !== imageVersion) return;
        activePrimary = ok ? src : fallbackImg;
        if (!isPointerOver || !activeHover) applyMainImage(activePrimary, s.name, version);
      });

      if (secondary) {
        requestImage(secondary, function (ok, src) {
          if (destroyed || version !== imageVersion) return;
          activeHover = ok ? src : "";
          if (isPointerOver && activeHover) applyMainImage(activeHover, s.name, version);
        });
      }
    }

    function warmSlide(i) {
      var s = slides[i];
      if (!s) return;
      requestImage(s.img, function () {});
      if (s.hoverImg && s.hoverImg !== s.img) requestImage(s.hoverImg, function () {});
    }

    function onCardEnter() {
      isPointerOver = true;
      if (activeHover) applyMainImage(activeHover, slides[idx].name, imageVersion);
    }

    function onCardLeave() {
      isPointerOver = false;
      applyMainImage(activePrimary || fallbackImg, slides[idx].name, imageVersion);
    }

    card.addEventListener("mouseenter", onCardEnter);
    card.addEventListener("mouseleave", onCardLeave);

    if (imgEl) {
      imgEl.addEventListener("error", function () {
        var failed = imgEl.getAttribute("src") || "";
        if (failed === activeHover) activeHover = "";
        if (failed === activePrimary) activePrimary = fallbackImg;
        if (fallbackImg && failed !== fallbackImg) imgEl.src = fallbackImg;
      });
    }

    dotsWrap.innerHTML = "";
    slides.forEach(function (s, i) {
      var b = document.createElement("button");
      b.type = "button"; b.className = "lvh-hcard2__dot" + (i === 0 ? " is-active" : "");
      b.setAttribute("aria-label", "Produkt " + (i + 1));
      b.addEventListener("click", function (e) { e.preventDefault(); e.stopPropagation(); go(i); });
      dotsWrap.appendChild(b);
    });
    var dots = dotsWrap.querySelectorAll(".lvh-hcard2__dot");
    function pad(n) { return String(n).padStart(2, "0"); }

    function render() {
      var s = slides[idx];
      var sub = typeof s.sub === "string" ? s.sub : "";
      var price = parseFloat(String(s.price).replace(",", ".")) || 0;
      var was = parseFloat(String(s.was).replace(",", ".")) || 0;
      updateProductImages(s);
      if (offEl) {
        if (was > price && price > 0) { offEl.style.display = ""; offEl.textContent = "-" + Math.round(((was - price) / was) * 100) + "%"; }
        else offEl.style.display = "none";
      }
      if (mizEl) mizEl.innerHTML = mizajHtml(s.mizaj);
      if (nameEl) nameEl.textContent = s.name || "";
      if (sizeEl) sizeEl.textContent = sub ? sub.split("·")[0].trim() : "";
      if (nowEl) { nowEl.textContent = fmt(price); nowEl.classList.toggle("is-sale", was > price); }
      if (wasEl) { if (was > price) { wasEl.style.display = ""; wasEl.textContent = fmt(was); } else wasEl.style.display = "none"; }
      if (unitEl) {
        var shopifyUnitPrice = typeof s.unitPriceText === "string" ? s.unitPriceText.trim() : "";
        var b = shopifyUnitPrice ? null : parseBaseAmount(sub);
        if (shopifyUnitPrice) { unitEl.style.display = ""; unitEl.textContent = shopifyUnitPrice; }
        else if (b && price > 0) { unitEl.style.display = ""; unitEl.textContent = fmt(price / b.qty) + " / " + b.unit; }
        else { unitEl.style.display = "none"; unitEl.textContent = ""; }
      }
      if (originEl) {
        var fl = s.flags ? '<span class="fl">' + s.flags + '</span>' : "";
        originEl.innerHTML = (s.origin || s.flags) ? (fl + '<span>' + (s.origin || "") + '</span>') : "";
      }
      if (s.href) card.setAttribute("href", s.href);
      if (countEl) countEl.textContent = pad(idx + 1) + " / " + pad(slides.length);
      dots.forEach(function (d, i) { d.classList.toggle("is-active", i === idx); });
      warmSlide((idx + 1) % slides.length);
    }

    function loop(ts) {
      if (startTime === null) startTime = ts;
      var p = Math.min(100, ((ts - startTime) / DURATION) * 100);
      if (barEl) barEl.style.width = p + "%";
      if (ts - startTime >= DURATION) { idx = (idx + 1) % slides.length; startTime = null; render(); }
      raf = window.requestAnimationFrame(loop);
    }
    function go(i) { idx = i; startTime = null; render(); }

    render();
    if (!window.matchMedia || !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      raf = window.requestAnimationFrame(loop);
    }
    root._lvhTeardown = function () {
      destroyed = true;
      imageVersion++;
      if (raf) window.cancelAnimationFrame(raf);
      card.removeEventListener("mouseenter", onCardEnter);
      card.removeEventListener("mouseleave", onCardLeave);
    };
  }

  /* ---- count-up ---- */
  function initCountups(scope) {
    var els = (scope || document).querySelectorAll("[data-countup]");
    els.forEach(function (el) {
      if (el._lvhCounted) return;
      var target = parseInt(el.getAttribute("data-countup"), 10) || 0;
      var suffix = el.getAttribute("data-suffix"); if (suffix === null) suffix = "+";
      var run = function () {
        if (el._lvhCounted) return; el._lvhCounted = true;
        var dur = 1200, start = null;
        function tick(now) {
          if (start === null) start = now;
          var p = Math.min((now - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.floor(eased * target).toLocaleString("de-DE") + suffix;
          if (p < 1) requestAnimationFrame(tick); else el.textContent = target.toLocaleString("de-DE") + suffix;
        }
        requestAnimationFrame(tick);
      };
      if ("IntersectionObserver" in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { run(); io.disconnect(); } });
        }, { threshold: 0.1 });
        io.observe(el);
      } else run();
    });
  }

  /* ---- horizontal scroller (arrows + fade) ---- */
  function initScrollers(scope) {
    (scope || document).querySelectorAll("[data-lvh-scroller]").forEach(function (root) {
      if (root._lvhScroller) return; root._lvhScroller = true;
      var vp = root.querySelector("[data-scroller-viewport]");
      var left = root.querySelector("[data-scroller-left]");
      var right = root.querySelector("[data-scroller-right]");
      if (!vp) return;
      function update() {
        if (left) left.hidden = vp.scrollLeft <= 4;
        if (right) right.hidden = vp.scrollLeft + vp.clientWidth >= vp.scrollWidth - 4;
      }
      function by(dir) { vp.scrollBy({ left: dir * vp.clientWidth * 0.8, behavior: "smooth" }); }
      if (left) left.addEventListener("click", function () { by(-1); });
      if (right) right.addEventListener("click", function () { by(1); });
      vp.addEventListener("scroll", update, { passive: true });
      window.addEventListener("resize", update);
      update();
    });
  }

  /* ---- Bestseller showcase carousel ---- */
  function escapeHtml(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function computeBase(variant, price) {
    var m = variant && variant.match(/(\d+(?:[.,]\d+)?)\s*(kg|g|ml|l)\b/i);
    if (!m) return null;
    var val = parseFloat(m[1].replace(",", ".")), u = m[2].toLowerCase(), qty, unit;
    if (u === "kg") { qty = val; unit = "kg"; } else if (u === "g") { qty = val / 1000; unit = "kg"; }
    else if (u === "l") { qty = val; unit = "l"; } else { qty = val / 1000; unit = "l"; }
    if (qty <= 0) return null;
    return fmt(price / qty) + " / " + unit;
  }
  function bestCard(p, bio) {
    var price = parseFloat(String(p.price).replace(",", ".")) || 0;
    var was = parseFloat(String(p.was).replace(",", ".")) || 0;
    var off = (was > price && price > 0) ? '<span class="lvh-bcard2__off">-' + Math.round((was - price) / was * 100) + "%</span>" : "";
    var stars = ""; for (var i = 0; i < 5; i++) stars += '<svg viewBox="0 0 24 24"><path d="M12 2l2.9 6.3 6.9.6-5.2 4.5 1.6 6.7L12 17l-6.2 3.6 1.6-6.7L2.2 8.9l6.9-.6z"/></svg>';
    var base = computeBase(p.variant, price);
    var flags = p.flags ? '<span class="fl">' + p.flags + "</span>" : "";
    var miz = (p.mizaj && MIZAJ[p.mizaj]) ? '<span class="lvh-bcard2__mizaj">' + mizajHtml(p.mizaj) + "</span>" : "";
    return '<a href="' + (p.href || "/collections/alle-produkte") + '" class="lvh-bcard2">'
      + '<div class="lvh-bcard2__imgwrap">'
      + '<img class="lvh-bcard2__img" src="' + p.img + '" alt="' + escapeHtml(p.name) + '" loading="lazy">'
      + '<img class="lvh-bcard2__bio" src="' + bio + '" alt="EU Bio Siegel" loading="lazy">'
      + off
      + '<span class="lvh-bcard2__cart" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/></svg></span>'
      + miz
      + "</div>"
      + '<h3 class="lvh-bcard2__name">' + escapeHtml(p.name) + "</h3>"
      + '<div class="lvh-bcard2__rating"><span class="lvh-bcard2__stars">' + stars + '</span><span class="lvh-bcard2__rev">(' + (p.reviews || 0) + ")</span></div>"
      + '<span class="lvh-bcard2__vchip">' + escapeHtml(p.variant || "") + "</span>"
      + '<div class="lvh-bcard2__price"><span class="now' + (was > price ? " is-sale" : "") + '">' + fmt(price) + "</span>" + (was > price ? '<span class="was">' + fmt(was) + "</span>" : "") + "</div>"
      + (base ? '<div class="lvh-bcard2__unit">' + base + "</div>" : "")
      + '<div class="lvh-bcard2__origin">' + flags + "<span>" + (p.origin || "") + "</span></div>"
      + "</a>";
  }
  function initBestseller(root) {
    if (root._lvhBest) return; root._lvhBest = true;
    var dataEl = root.querySelector(".lvh-best__data"); var items = [];
    try { items = JSON.parse(dataEl.textContent); } catch (e) {}
    items = items.filter(function (p) { return p && p.name; });
    if (!items.length) return;
    var grid = root.querySelector("[data-best-grid]"), dotsWrap = root.querySelector("[data-best-dots]"),
        prev = root.querySelector("[data-best-prev]"), next = root.querySelector("[data-best-next]"),
        bioEl = root.querySelector("[data-best-bio]"), bio = bioEl ? bioEl.getAttribute("data-best-bio") : "";
    var n = items.length, start = 0, pageCount = Math.max(1, n - 1);
    dotsWrap.innerHTML = "";
    for (var i = 0; i < pageCount; i++) (function (i) {
      var b = document.createElement("button"); b.type = "button"; b.className = "lvh-best__dot" + (i === 0 ? " is-active" : "");
      b.setAttribute("aria-label", "Slide " + (i + 1)); b.addEventListener("click", function () { start = i; render(); });
      dotsWrap.appendChild(b);
    })(i);
    var dots = dotsWrap.querySelectorAll(".lvh-best__dot");
    function render() {
      grid.innerHTML = bestCard(items[start], bio) + bestCard(items[(start + 1) % n], bio);
      dots.forEach(function (d, i) { d.classList.toggle("is-active", i === start); });
    }
    function go(d) { start = (start + d + n) % n; render(); }
    if (prev) prev.addEventListener("click", function () { go(-1); });
    if (next) next.addEventListener("click", function () { go(1); });
    var sx = null, sy = null;
    grid.addEventListener("touchstart", function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    grid.addEventListener("touchend", function (e) { if (sx == null) return; var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy; if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1); sx = null; sy = null; });
    render();
  }

  /* ---- Category showcase (9 tabs) ---- */
  function mizajFor(name) {
    var n = (name || "").toLowerCase();
    if (/rosen(öl|oel)/.test(n)) return "kaltTrocken";
    if (/talbina|gerste/.test(n)) return "kaltTrocken";
    if (/omega|algen|leinsamen(?!\s*honig)/.test(n)) return "kaltFeucht";
    if (/dattel|medjool|rutab/.test(n)) return "warmFeucht";
    if (/mandel(öl|oel|mus|mehl)/.test(n)) return "warmFeucht";
    if (/leinöl|leinoel/.test(n)) return "warmFeucht";
    if (/schwarzkümmel|schwarzkuemmel|nigella/.test(n)) return "warmTrocken";
    if (/honig/.test(n)) return "warmTrocken";
    if (/safran|weihrauch|oud|rizinus/.test(n)) return "warmTrocken";
    if (/salbei|thymian|lavendel|kräuter|kraeuter/.test(n)) return "warmTrocken";
    if (/ashwagandha|vital|d3|vitamin/.test(n)) return "warmTrocken";
    return "";
  }
  var CSH_ICON = {
    flame: '<path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.07-2.14-.22-4.05 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.15.43-2.29 1-3a2.5 2.5 0 0 0 2.5 2.5z"/>',
    sun: '<circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"/>',
    flask: '<path d="M9 3h6"/><path d="M10 3v6.5a2 2 0 0 1-.4 1.2L4.3 17.8A2 2 0 0 0 6 21h12a2 2 0 0 0 1.7-3.2l-5.3-7.1a2 2 0 0 1-.4-1.2V3"/>',
    leaf: '<path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z"/><path d="M2 21c0-3 1.85-5.36 5.08-6"/>',
    shield: '<path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/><path d="m9 12 2 2 4-4"/>',
    sparkles: '<path d="M9.94 14.06 4 20m6.66-9.34L4 4m12.06 5.94L20 4m-3.34 9.34L20 20"/>',
    droplet: '<path d="M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z"/>',
    flower: '<circle cx="12" cy="12" r="3"/><path d="M12 16.5A4.5 4.5 0 1 1 7.5 12M12 7.5A4.5 4.5 0 1 1 16.5 12M7.5 12A4.5 4.5 0 1 1 12 16.5M16.5 12A4.5 4.5 0 1 1 12 7.5"/>',
    wheat: '<path d="M2 22 16 8"/><path d="M3.47 12.53 5 11l1.53 1.53a3.5 3.5 0 0 1 0 4.94L5 19l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z"/><path d="M7.47 8.53 9 7l1.53 1.53a3.5 3.5 0 0 1 0 4.94L9 15l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z"/><path d="M11.47 4.53 13 3l1.53 1.53a3.5 3.5 0 0 1 0 4.94L13 11l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z"/>'
  };
  var CSH_TABS = [
    { id:"schwarzkuemmel", label:"Schwarzkümmel", eyebrow:"Bio Schwarzkümmel", headline:'<span class="lvh-gold">Mühlenfrisch</span> gepresst. Ungefiltert. Laborgeprüft.', cta:{l:"Alle Schwarzkümmel Produkte",h:"/collections/schwarzkuemmel"}, box:{i:"flame",k:"Natürliche Balance, ohne Zusätze",hl:'Kein zugesetztes Thymoquinon, <span class="lvh-gold">nur die natürliche Balance</span> der Saat.',t:"Wir manipulieren nichts, kein isoliertes Thymoquinon, keine Konzentrate. Abgefüllt in Ultraviolettglas als Oxidationsschutz, damit Wirkstoffe und Fettsäuren stabil bleiben. Jede Charge unabhängig laborgeprüft.",c:{l:"Laborwerte ansehen →",h:"/collections/schwarzkuemmel"}}, p:[
      {n:"Bio Schwarzkümmelöl",s:"250 ml · Ungefiltert",p:36,w:44,t:"Bestseller",o:"DE & Ägypten",f:"🇩🇪 🇪🇬",h:"/collections/schwarzkuemmel"},
      {n:"Schwarzkümmelöl Vorteilsset",s:"3 × 250 ml",p:102.6,w:132,t:"Spare 22 %",o:"DE & Ägypten",f:"🇩🇪 🇪🇬",h:"/collections/schwarzkuemmel"},
      {n:"Schwarzkümmel ganz",s:"500 g · Bio Nigella Sativa",p:14,o:"Ägypten",f:"🇪🇬",h:"/collections/schwarzkuemmel"},
      {n:"Schwarzkümmel in Honig",s:"500 g · roh · DNA-Test",p:22,t:"DNA-Test",o:"DE & Ägypten",f:"🇩🇪 🇪🇬",h:"/collections/schwarzkuemmel"} ] },
    { id:"datteln", label:"Datteln", eyebrow:"Bio Datteln, Royal Qualität", headline:'<span class="lvh-gold">Sonnengereift</span> in Medina & Al Qasim, Saudi Arabien.', cta:{l:"Alle Datteln",h:"/collections/datteln"}, box:{i:"sun",k:"Bio Qualität, aus erster Hand",hl:'Alles in <span class="lvh-gold">Bio Qualität</span>, aus erster Hand ohne Zwischenhändler.',t:"Wir beziehen unsere Datteln direkt aus den Palmenhainen unserer Partnerfarmen. Unbehandelt, ungeschwefelt, ohne Zuckerglasur. Vom Baum in den Karton, keine Zwischenschritte.",c:{l:"Herkunft ansehen →",h:"/collections/datteln"}}, p:[
      {n:"Medjool Datteln",s:"1 kg · Royal Qualität",p:24,w:29,t:"Bestseller",o:"Saudi Arabien",f:"🇸🇦",h:"/collections/datteln"},
      {n:"Medjool Probier Set",s:"3 Sorten · 750 g",p:32,w:42,t:"Spare 24 %",o:"Saudi Arabien",f:"🇸🇦",h:"/collections/datteln"},
      {n:"Rutab Datteln",s:"500 g · saisonal",p:18,t:"Saison",o:"Saudi Arabien",f:"🇸🇦",h:"/collections/datteln"},
      {n:"Datteln in Honig",s:"500 g",p:19,o:"Saudi Arabien & DE",f:"🇸🇦 🇩🇪",h:"/collections/datteln"} ] },
    { id:"honig", label:"Honig", eyebrow:"Bio Sortenhonig · DNA-Test verifiziert", headline:'<span class="lvh-gold">DNA-geprüft</span> echt. Roh. Aus Bayerns Waldschutzgebiet.', cta:{l:"Alle Honige",h:"/collections/honig"}, box:{i:"flask",k:"DNA Test verifiziert",hl:'Blütenhonig als <span class="lvh-gold">Basis unserer Mazerate</span>, deshalb DNA getestet.',t:"Unser Blütenhonig ist die Basis für Leinsamen in Honig und Schwarzkümmel in Honig, jede Charge im Labor per DNA Analyse auf botanische Echtheit geprüft. Kein Panschen, kein Zuckersirup, wiederkehrende Pestizidtests pro Charge.",c:{l:"Laborbericht ansehen →",h:"/collections/honig"}}, p:[
      {n:"Bio Wildblüten Honig",s:"500 g · roh · DNA-Test",p:18,t:"DNA-Test",o:"Bayern",f:"🇩🇪",h:"/collections/honig"},
      {n:"Bio Leinsamen in Honig",s:"500 g · roh · DNA-Test",p:19,t:"DNA-Test",o:"Bayern",f:"🇩🇪",h:"/products/bio-leinsamen-in-honig-500g"},
      {n:"Bio Sortenhonig Akazie",s:"500 g · roh",p:18,w:22,t:"Bestseller",o:"Bayern",f:"🇩🇪",h:"/collections/honig"},
      {n:"Honig Probier Set",s:"3 × 250 g",p:32,w:39,t:"Beliebt",o:"Bayern",f:"🇩🇪",h:"/collections/honig"} ] },
    { id:"kraeuter", label:"Kräuter", eyebrow:"Wildkräuter & Tee", headline:'<span class="lvh-gold">Wild</span> gesammelt. Luftgetrocknet unter 35 °C.', cta:{l:"Alle Kräuter",h:"/collections/krauter"}, box:{i:"leaf",k:"Schonend luftgetrocknet",hl:'Wild gesammelt und unter <span class="lvh-gold">35 °C</span> luftgetrocknet.',t:"Ätherische Öle, Enzyme und Aromen bleiben erhalten. Handverlesen aus unbelasteten Regionen, ohne Bestrahlung, ohne Rieselhilfen. Reinheit auf Rückstände und Schwermetalle unabhängig geprüft.",c:{l:"Herkunft & Prüfung →",h:"/collections/krauter"}}, p:[
      {n:"Wildkräuter Tee",s:"100 g · luftgetrocknet",p:14,o:"Deutschland",f:"🇩🇪",h:"/collections/krauter"},
      {n:"Salbei wild",s:"80 g · Ganzblatt",p:12,o:"Deutschland",f:"🇩🇪",h:"/collections/krauter"},
      {n:"Thymian wild",s:"80 g · Ganzblatt",p:12,o:"Deutschland",f:"🇩🇪",h:"/collections/krauter"},
      {n:"Kräuter Probier Set",s:"4 Sorten",p:38,w:48,t:"Spare 21 %",o:"Deutschland",f:"🇩🇪",h:"/collections/krauter"} ] },
    { id:"extrakte", label:"Extrakte", eyebrow:"Supplemente & Extrakte", headline:'Hochdosiert. Pflanzlich. <span class="lvh-gold">Laborgeprüft.</span>', cta:{l:"Alle Extrakte",h:"/collections/bio-extrakte"}, box:{i:"shield",k:"Nur Wirkstoff, keine Füller",hl:'Omega 3 und Ashwagandha, <span class="lvh-gold">100 % nur das drin, was draufsteht</span>.',t:"Keine unnötigen Trägerstoffe, kein Magnesiumstearat, keine Nano Zusätze. Abgesehen von der Kapselhülle enthalten unsere Extrakte ausschließlich den deklarierten Wirkstoff. Jede Charge auf Gehalt, Reinheit und Schadstoffe geprüft.",c:{l:"Analysen ansehen →",h:"/collections/bio-extrakte"}}, p:[
      {n:"Omega 3 Algenöl",s:"120 Kapseln · vegan",p:29,w:35,t:"Bestseller",o:"Deutschland",f:"🇩🇪",h:"/collections/bio-extrakte"},
      {n:"Ashwagandha KSM-66",s:"120 Kapseln · 600 mg",p:24,w:29,t:"Neu",o:"Indien",f:"🇮🇳",h:"/products/bio-ashwagandha-180-kapseln"},
      {n:"Vital Set",s:"Omega 3 + Ashwagandha",p:48,w:64,t:"Spare 25 %",o:"DE & Indien",f:"🇩🇪 🇮🇳",h:"/collections/bio-extrakte"},
      {n:"Omega 3 Familien Set",s:"3 × 120 Kapseln",p:79,w:105,o:"Deutschland",f:"🇩🇪",h:"/collections/bio-extrakte"} ] },
    { id:"gewuerze", label:"Gewürze", eyebrow:"Bio Gewürze & Spezialitäten", headline:'<span class="lvh-gold">Sortenrein.</span> Herkunftsgeprüft. Aromaintensiv.', cta:{l:"Alle Gewürze",h:"/collections/bio-safran"}, box:{i:"sparkles",k:"Unverfälscht, höchste Klasse",hl:'Safran in <span class="lvh-gold">ganzen Fäden, Negin Qualität</span>, die höchste Klasse.',t:"Unverfälscht, sortenrein und herkunftsgeprüft. Nur ganze Fäden, kein Pulver, kein Streckmittel, keine Farbstoffe, keine Bestrahlung. Jede Charge nach ISO Kriterien analysiert.",c:{l:"Qualitätsstufen ansehen →",h:"/collections/bio-safran"}}, p:[
      {n:"Bio Safran Fäden",s:"2 g · Negin · Iran",p:24,w:29,t:"Premium",o:"Iran",f:"🇮🇷",h:"/collections/bio-safran"},
      {n:"Sokotra Weihrauch",s:"50 g · Wildernte",p:28,t:"Selten",o:"Jemen (Sokotra)",f:"🇾🇪",h:"/collections/atherische-ole"},
      {n:"Schwarzkümmel ganz",s:"500 g · Nigella Sativa",p:14,o:"Ägypten",f:"🇪🇬",h:"/products/bio-schwarzkummelsamen-200g"} ] },
    { id:"speiseoele", label:"Speiseöle", eyebrow:"Bio Leinsamenöl", headline:'<span class="lvh-gold">Kaltgepresst</span> unter 37 °C. Mühlenfrisch aus Deutschland.', cta:{l:"Alle Speiseöle",h:"/collections/ole"}, box:{i:"droplet",k:"Hoher ALA Gehalt, Ultraviolettglas",hl:'Leinsamenöl mit <span class="lvh-gold">natürlich hohem ALA Gehalt</span>, geschützt im Ultraviolettglas.',t:"Kaltgepresst unter 37 °C, ungefiltert und mühlenfrisch aus deutscher Ölmühle. Das Ultraviolettglas blockiert oxidatives Licht, so bleiben Omega 3 Fettsäuren und Antioxidantien stabil. Erst gepresst, wenn du bestellst.",c:{l:"Pressprozess ansehen →",h:"/collections/ole"}}, p:[
      {n:"Bio Schwarzkümmelöl",s:"250 ml · ungefiltert",p:36,w:44,t:"Bestseller",o:"DE & Ägypten",f:"🇩🇪 🇪🇬",h:"/collections/schwarzkuemmel"},
      {n:"Bio Leinöl",s:"250 ml · Omega 3",p:14,o:"Deutschland",f:"🇩🇪",h:"/collections/ole"},
      {n:"Bio Mandelöl",s:"250 ml · süß",p:18,o:"Spanien",f:"🇪🇸",h:"/collections/ole"},
      {n:"Bio Mandelmus weiß",s:"500 g · Marcona",p:22,o:"Spanien",f:"🇪🇸",h:"/collections/alle-produkte"} ] },
    { id:"aetherische", label:"Ätherische Öle", eyebrow:"Ätherische & Parfümöle", headline:'<span class="lvh-gold">Naturrein.</span> Ohne Alkohol. Ohne Synthetik.', cta:{l:"Alle ätherischen Öle",h:"/collections/atherische-ole"}, box:{i:"flower",k:"Wasserdampfdestilliert, 100 % naturrein",hl:'Reine ätherische Öle, <span class="lvh-gold">schonend wasserdampfdestilliert</span>.',t:"Aus Blüten, Harzen und Hölzern gewonnen, ohne Alkohol, ohne Synthetik, ohne Streckmittel. Jede Charge per GC-MS auf Reinheit und Zusammensetzung analysiert.",c:{l:"Reinheitsanalyse →",h:"/collections/atherische-ole"}}, p:[
      {n:"Rosenöl Parfüm",s:"10 ml · Rosa Damascena",p:39,t:"Beliebt",o:"Bulgarien",f:"🇧🇬",h:"/collections/atherische-ole"},
      {n:"Oud Öl Parfüm",s:"3 ml · 100 % pur",p:89,t:"Premium",o:"Indonesien",f:"🇮🇩",h:"/collections/atherische-ole"},
      {n:"Bio Rizinusöl",s:"100 ml · Violettglas",p:14,o:"Indien",f:"🇮🇳",h:"/collections/ole"},
      {n:"Bio Mandelöl Pflege",s:"250 ml · kaltgepresst",p:18,o:"Spanien",f:"🇪🇸",h:"/collections/ole"} ] },
    { id:"mehl", label:"Mehl", eyebrow:"Vollwertige Mehle", headline:'<span class="lvh-gold">Frisch vermahlen.</span> Mykotoxin geprüft. Vollwertig.', cta:{l:"Alle Mehle",h:"/collections/mehl"}, box:{i:"wheat",k:"Frisch vermahlen, vollwertig",hl:'Vollkorn frisch vermahlen und <span class="lvh-gold">Mykotoxin geprüft</span>.',t:"Talbina aus ganzer Bio Gerste, Mandelmehl entölt und fein gemahlen. Jede Charge auf Aflatoxine und Schwermetalle geprüft. Ohne Zusätze, ohne Konservierung, ohne Aromen.",c:{l:"Qualitätsprüfung →",h:"/collections/mehl"}}, p:[
      {n:"Bio Talbina Gerste",s:"500 g · vollkorn",p:12,t:"Sunnah",o:"Deutschland",f:"🇩🇪",h:"/collections/mehl"},
      {n:"Bio Mandelmehl entölt",s:"500 g · glutenfrei",p:16,o:"Spanien",f:"🇪🇸",h:"/collections/mehl"} ] }
  ];
  function cshCard(p, bio, img) {
    var price = p.p || 0, was = p.w || 0;
    var badge = (was > price) ? '<span class="lvh-pctile__off">-' + Math.round((was - price) / was * 100) + "%</span>"
      : (p.t ? '<span class="lvh-pctile__tag">' + escapeHtml(p.t) + "</span>" : "");
    var stars = ""; for (var i = 0; i < 5; i++) stars += '<svg viewBox="0 0 24 24"><path d="M12 2l2.9 6.3 6.9.6-5.2 4.5 1.6 6.7L12 17l-6.2 3.6 1.6-6.7L2.2 8.9l6.9-.6z"/></svg>';
    var b = parseBaseAmount(p.s), unit = (b && price > 0) ? '<div class="lvh-pctile__unit">' + fmt(price / b.qty) + " / " + b.unit + "</div>" : "";
    var mk = mizajFor(p.n), miz = mk ? '<span class="lvh-pctile__mizaj">' + mizajHtml(mk) + "</span>" : "";
    var size = p.s ? p.s.split("·")[0].trim() : "";
    var orig = (p.f || p.o) ? '<div class="lvh-pctile__origin">' + (p.f ? '<span class="fl">' + p.f + "</span>" : "") + "<span>" + (p.o || "") + "</span></div>" : "";
    return '<a href="' + (p.h || "/collections/alle-produkte") + '" class="lvh-pctile"><div class="lvh-pctile__imgwrap"><img class="im" src="' + img + '" alt="' + escapeHtml(p.n) + '" loading="lazy"><img class="bio" src="' + bio + '" alt="EU Bio Siegel" loading="lazy">' + badge + miz + '</div><div class="lvh-pctile__body"><span class="lvh-pctile__stars">' + stars + '</span><div class="lvh-pctile__name">' + escapeHtml(p.n) + '</div><span class="lvh-pctile__chip">' + escapeHtml(size) + '</span><div class="lvh-pctile__price"><span class="now' + (was > price ? " is-sale" : "") + '">' + fmt(price) + "</span>" + (was > price ? '<span class="was">' + fmt(was) + "</span>" : "") + "</div>" + unit + orig + "</div></a>";
  }
  function initCategoryShowcase(root) {
    if (root._lvhCsh) return; root._lvhCsh = true;
    var bio = root.getAttribute("data-csh-bio") || "";
    var fb = (root.getAttribute("data-csh-fb") || "").split(",");
    var moreL = root.getAttribute("data-csh-more-label") || "Mehr sehen";
    var lessL = root.getAttribute("data-csh-less-label") || "Weniger anzeigen";
    var headEl = root.querySelector("[data-csh-head]"), boxEl = root.querySelector("[data-csh-infobox]"),
        tabsEl = root.querySelector("[data-csh-tabs]"), gridEl = root.querySelector("[data-csh-grid]"), moreEl = root.querySelector("[data-csh-more]");
    var active = 0, showAll = false, INITIAL = 4;
    function render() {
      var tab = CSH_TABS[active];
      headEl.innerHTML = '<div><span class="lvh-eyebrow">' + escapeHtml(tab.eyebrow) + '</span><h2 class="lvh-csh__h2">' + tab.headline + '</h2></div><a href="' + tab.cta.h + '" class="lvh-link">' + escapeHtml(tab.cta.l) + ' →</a>';
      boxEl.innerHTML = '<div class="lvh-csh__box"><div class="lvh-csh__boxmain"><div class="lvh-csh__boxico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' + (CSH_ICON[tab.box.i] || "") + '</svg></div><div><span class="lvh-csh__boxk">' + escapeHtml(tab.box.k) + '</span><h3 class="lvh-csh__boxhl">' + tab.box.hl + '</h3><p class="lvh-csh__boxt">' + escapeHtml(tab.box.t) + '</p></div></div><a href="' + tab.box.c.h + '" class="lvh-csh__boxcta">' + escapeHtml(tab.box.c.l) + '</a></div>';
      tabsEl.innerHTML = CSH_TABS.map(function (t, i) { return '<button type="button" class="lvh-csh__tab' + (i === active ? " is-active" : "") + '" data-i="' + i + '">' + escapeHtml(t.label) + "</button>"; }).join("");
      tabsEl.querySelectorAll(".lvh-csh__tab").forEach(function (b) { b.addEventListener("click", function () { active = +b.getAttribute("data-i"); showAll = false; render(); }); });
      var prods = showAll ? tab.p : tab.p.slice(0, INITIAL);
      gridEl.innerHTML = prods.map(function (p, i) { return cshCard(p, bio, fb[i % fb.length]); }).join("");
      if (tab.p.length > INITIAL) {
        moreEl.innerHTML = '<button type="button" class="lvh-csh__morebtn">' + (showAll ? lessL : moreL + " (" + (tab.p.length - INITIAL) + ")") + "</button>";
        moreEl.querySelector("button").addEventListener("click", function () { showAll = !showAll; render(); });
      } else moreEl.innerHTML = "";
    }
    render();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll("[data-lvh-hero]").forEach(function (r) {
      if (r._lvhTeardown) r._lvhTeardown();
      initHero(r);
    });
    (scope || document).querySelectorAll("[data-lvh-best]").forEach(function (r) { r._lvhBest = false; initBestseller(r); });
    (scope || document).querySelectorAll("[data-lvh-csh]").forEach(function (r) { r._lvhCsh = false; initCategoryShowcase(r); });
    initCountups(scope);
    initScrollers(scope);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initAll(); });
  } else { initAll(); }
  document.addEventListener("shopify:section:load", function (e) { initAll(e.target); });
})();
